import Vue from 'vue'
import VueI18n from 'vue-i18n'

import config from '@/config'
import api from '@/api'
import setup from '@/setup'

Vue.use(VueI18n)

const loadedLanguages = []

// Export VueI18n instance with options.
const i18n = new VueI18n({
  fallbackLocale: 'en',
})

export function setLocale(locale) {
  i18n.locale = locale || 'en'
  localStorage.setItem('locale', locale)
  document.querySelector('html').setAttribute('lang', locale)
}

export function getLocale() {
  return i18n.locale
}

export function t(text) {
  return i18n.t(text)
}

/**
 * Loads the locale from remote server. Falls back to saved locale if needed.
 * Falls back to default locale if needed.
 *
 * @param {string} locale
 * @returns
 */
export async function loadLocale(locale) {
  // Fallback for old wrong Danish locale code 'dk'.
  if (locale === 'dk') {
    locale = 'da'
  }

  const mainConfig = setup.getMainConfig()

  // Check if locale is supported and use fallback if needed.
  if (!locale || !mainConfig.supportedLocales.includes(locale)) {
    locale = localStorage.getItem('locale') || config.fallbackLocale
  }

  // If the same language.
  if (i18n.locale === locale) {
    return
  }

  // If the language was already loaded.
  if (loadedLanguages.includes(locale)) {
    setLocale(locale)
    return
  }

  // Load the locale from remote. If it fails load fallback locale. If that fails give up.
  const [err, res] = await api
    .get('locales/:locale.json', { params: { locale } })
    .send()

  if (err) {
    if (locale !== config.fallbackLocale) {
      return await loadLocale(config.fallbackLocale)
    } else {
      return
    }
  }

  // Update VueI18n with loaded locale messages.
  i18n.setLocaleMessage(locale, res)

  // Remember loaded locale.
  loadedLanguages.push(locale)

  // Set locale to the new locale.
  return setLocale(locale)
}

export default i18n
